export const bookingFooterTemplate = `
<p style="margin: 0; font-size: 14px; line-height: 21px; color: #333333">
  <strong>made with love from xeetr</strong>
</p>
<div style="margin: 0; padding-top: 10px; padding-bottom: 10px">
  <p>© {{copyright}} GeeZee GmbH</p>
  <p>www.xeetr.de - www.geezee-it.de</p>
</div>
<div style="display: hidden">{{hiddenBookingId}}</div>
`
